import { call, put, takeEvery } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

function* createUploadImage(action) {
  const { file, type, uploadKey } = action.payload;

  let uuid = getSetCookie();

  try {
    const headers = {
      Authorization: `Bearer ${action.access}`,
      "X-RealmUuid": uuid,
    };

    const formDataToSend = new FormData();
    formDataToSend.append("file", file);
    formDataToSend.append("type", type);

    let url = apiUrl + "/upload-image";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const requestOptions = {
      headers: headers,
      body: formDataToSend,
    };

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.file && response.file.secure_url) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    if (response?.file?.secure_url) {
      yield put({
        type: "UPLOAD_IMAGE_SUCCESS",
        payload: { uploadKey, file: response.file },
      });
    } else {
      throw new Error("Invalid response from server");
    }
  } catch (error) {
    yield put({
      type: "UPLOAD_IMAGE_FAILURE",
      payload: {
        uploadKey,
        error: error.message || "An unknown error occurred",
      },
    });
  }
}

export function* createSagaUploadImage() {
  yield takeEvery("CREATE_UPLOAD_IMAGE", createUploadImage);
}

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};
